const WorkExperience = [
  {
    id: 1,
    title: "Junior AI/ML Engineer",
    type: "Full-time",
    company: "NGXP Technologies",
    yearsActive: "May 2026 - Present",
    information: [
      "Developing real-time camera-based vehicle and person detection system for L&T (Larsen & Toubro) using YOLOv8 for automated surveillance across industrial sites",
      "Building and annotating custom training datasets using Roboflow — image labelling, augmentation and dataset versioning for multi-class object detection",
      "Training and fine-tuning YOLO models on domain-specific datasets; integrating detection pipeline with live CCTV camera feeds for real-time inference and alert generation",
    ],
  },
  {
    id: 2,
    title: "Software Engineer",
    type: "Full-time",
    company: "Mitsogo Technologies (Hexnode)",
    yearsActive: "Jul 2025 - Mar 2026",
    information: [
      "Developed and maintained scalable full-stack features for the Hexnode UEM Portal using Django (Backend) and Angular (Frontend)",
      "Built and integrated secure RESTful APIs for device management, authentication and portal operations",
      "Implemented user management, access control and security modules in an Agile environment delivering production-ready features",
    ],
  },
  {
    id: 3,
    title: "Web Development Intern",
    type: "Internship",
    company: "Motion Cut (AICTE)",
    yearsActive: "Nov 2023 - Dec 2023",
    information: [
      "Developed responsive web applications using HTML, CSS, and JavaScript",
      "Implemented form validation and interactive UI components",
      "Built a functional food ordering website with modern design practices",
    ],
  },
  {
    id: 4,
    title: "Embedded C Intern",
    type: "Internship",
    company: "Emglitz Technologies",
    yearsActive: "May 2023 - Jun 2023",
    information: [
      "Built embedded system applications using Embedded C",
      "Worked on hardware-software integration and real-time system logic",
      "Gained hands-on experience with microcontroller-based systems",
    ],
  },
  {
    id: 5,
    title: "VLSI Intern",
    type: "Internship",
    company: "Sevael Technologies Pvt Ltd",
    yearsActive: "Jul 2022 - Aug 2022",
    information: [
      "Worked on VLSI design using industry-standard tools",
      "Learned fundamentals of IC design and semiconductor technologies",
      "Implemented basic circuit design and simulation concepts",
    ],
  },
  // {
  //     id: 4,
  //     title: "Software Development Intern",
  //     company: "The Digital Academy",
  //     yearsActive: "Novembe 2015 - January 2016",
  //     information: [
  //         "Served as a dedicated and supportive Intern in a fast-paced environment",
  //         "Worked to solve complex problems using the latest in Mobile and Web Technologies.",
  //     ],
  // },
  // {
  //     id: 5,
  //     title: "IT Support Assistant",
  //     company: "Varsity College",
  //     yearsActive: "February 2015 - May 2015",
  //     information: [
  //         "Worked to support the senior support staff with day-to-day tasks.",
  //         "Assisted with the evaluation and troubleshooting of hardware and software issues.",
  //         "Maintaining computer Inventory & surplus equipment."
  //     ],
  // },
  // {
  //     id: 6,
  //     title: "Student Ambassador",
  //     company: "Varsity College",
  //     yearsActive: "December 2014 - February 2015",
  //     information: [
  //         "Monitored registration for all prospective student",
  //         "Assisted parents and prospective student with necessary registration details",
  //     ],
  // },
];

export default WorkExperience;
